import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/95 backdrop-blur-lg shadow-lg shadow-[#D4AF37]/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-32">
          {/* Logo */}
          <a href="#home" className="flex items-center group relative py-4">
            <div className="relative flex flex-col items-center">
              {/* Glowing effect behind logo */}
              <div className="absolute inset-0 bg-[#D4AF37]/20 blur-xl rounded-full scale-110 group-hover:bg-[#D4AF37]/30 transition-all"></div>
              
              {/* Logo image with high-tech effects */}
              <img 
                src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/24151a9b24e2ba5e0b07eb7354fcf6e7.jpeg"
                alt="A&H Junk Removal"
                className="relative h-24 w-auto object-contain filter drop-shadow-[0_0_8px_rgba(212,175,55,0.6)] group-hover:drop-shadow-[0_0_12px_rgba(212,175,55,0.8)] transition-all duration-300 group-hover:scale-105"
              />
              
              {/* Family Owned text */}
              <span className="text-[10px] text-[#D4AF37] font-semibold tracking-wider uppercase mt-1">Family Owned &amp; Operated</span>
              
              {/* Scan line effect */}
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#D4AF37]/10 to-transparent animate-pulse pointer-events-none"></div>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-gray-300 hover:text-[#D4AF37] transition-colors tracking-wider uppercase"
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              className="px-6 py-2.5 bg-[#D4AF37] text-black font-semibold text-sm rounded-lg hover:bg-[#E5C158] transition-all hover:shadow-lg hover:shadow-[#D4AF37]/30 whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
        >
          <div className="flex flex-col gap-4 pt-4 border-t border-gray-800 bg-black/95 backdrop-blur-lg px-4 rounded-b-lg">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-300 hover:text-[#D4AF37] transition-colors py-2"
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-6 py-3 bg-[#D4AF37] text-black font-semibold text-center rounded-lg mt-2 cursor-pointer whitespace-nowrap"
            >
              Get Free Quote
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
